import SelectAll from './SelectAll.component';

export default SelectAll;
